import {SignableDocumentType, SpouseSigningMode} from "@/constants/SignatureConstants";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CreatePrefilledPersonDocumentPayload {
    type: SignableDocumentType | null = null;
    personId: number | null = null;
    spouseSigningMode: SpouseSigningMode | null = SpouseSigningMode.IGNORED;
    file: FileMetaDTO | null = null;
}